import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import SpritesheetAnim from '../../components/SpritesheetAnim';
import Ground from './Ground';

import MikeSpriteSheet from '../../assets/main/main-character-row.png';
import WarriorSpriteSheet from '../../assets/warrior/warrior-row.png';
import MageSpriteSheet from '../../assets/mage/mage-row.png';
import HunterSpriteSheet from '../../assets/hunter/hunter-row.png';

import mikeConfigs, {
  hunterConfigs,
  mageConfigs,
  warriorConfigs,
} from '../../constants/spriteConfigs';

import './styles.css';

const propTypes = {
  blockScroll: PropTypes.func.isRequired,
  canAnim: PropTypes.func.isRequired,
  move: PropTypes.string.isRequired,
  charClass: PropTypes.string.isRequired,
  changeSprite: PropTypes.string,
  changeSpriteConfs: PropTypes.oneOfType([PropTypes.object]),
  speedValues: PropTypes.oneOfType([PropTypes.object]),
  scrollPos: PropTypes.number,
  charAttack: PropTypes.bool.isRequired,
  startAttack: PropTypes.func.isRequired,
  stopMove: PropTypes.bool.isRequired,
  showMessage: PropTypes.string,
  tryToSend: PropTypes.func.isRequired,
  sendEmail: PropTypes.bool.isRequired,
  characterIsLoaded: PropTypes.func,
  messageHidden: PropTypes.func.isRequired,
  freezeSpriteFrame: PropTypes.string.isRequired,
};

const defaultProps = {
  changeSprite: MikeSpriteSheet,
  changeSpriteConfs: mikeConfigs,
  speedValues: {},
  scrollPos: 0,
  showMessage: '',
  characterIsLoaded: () => { },
};

const MESSAGES = {
  prepare: 'prepare',
  waiting: 'waiting',
  invalidEmail: 'invalidEmail',
  emptyFields: 'emptyFields',
  errorSendEmail: 'errorSendEmail',
  success: 'success',
  sayHey: 'sayHey',
  landscape: 'landscape',
  portrait: 'portrait',
};

export default class BottomLayer extends Component {
  constructor(props) {
    super(props);

    this.ground = React.createRef();
    this.timer = null;

    const { move, changeSprite, changeSpriteConfs } = this.props;

    this.state = {
      sprite: changeSprite,
      spriteConfs: changeSpriteConfs,
      move,
      jumpToAttack: false,
      messageType: '',
    };
  }

  componentDidUpdate(prevProps) {
    const {
      move, changeSprite, changeSpriteConfs, showMessage, sendEmail,
    } = this.props;

    if (prevProps.move !== move) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ move });
    }

    if (
      prevProps.changeSprite !== changeSprite
      && prevProps.changeSpriteConfs !== changeSpriteConfs
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        sprite: changeSprite,
        spriteConfs: changeSpriteConfs,
      });
    }

    if (prevProps.sendEmail !== sendEmail && showMessage !== '') {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      this.changeMessage(showMessage);
    }

    if (prevProps.showMessage !== showMessage && showMessage !== '') {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      this.changeMessage(showMessage);
    }
  }

  changeCharacter = charClass => {
    const { blockScroll } = this.props;

    blockScroll(false);

    switch (charClass) {
      case 'warrior':
        this.setState({
          sprite: WarriorSpriteSheet,
          spriteConfs: warriorConfigs,
        });
        break;
      case 'mage':
        this.setState({
          sprite: MageSpriteSheet,
          spriteConfs: mageConfigs,
        });
        break;
      case 'hunter':
        this.setState({
          sprite: HunterSpriteSheet,
          spriteConfs: hunterConfigs,
        });
        break;
      default:
        this.setState({
          sprite: MikeSpriteSheet,
          spriteConfs: mikeConfigs,
        });
        break;
    }
  };

  changeMessage = message => {
    const { messageHidden } = this.props;
    let messageType = '';
    let emailState = false;

    switch (message) {
      case MESSAGES.prepare:
        emailState = true;
        break;
      case MESSAGES.waiting:
        messageType = 'waiting';
        emailState = true;
        break;
      case MESSAGES.invalidEmail:
        messageType = 'invalid-email';
        emailState = true;
        break;
      case MESSAGES.emptyFields:
        messageType = 'empty-fields';
        emailState = true;
        break;
      case MESSAGES.errorSendEmail:
        messageType = 'error-send-email';
        emailState = true;
        break;
      case MESSAGES.success:
        messageType = 'success';
        break;
      case MESSAGES.sayHey:
        messageType = 'hello-message';
        break;
      case MESSAGES.landscape:
        messageType = 'rotate-warning';
        emailState = true;
        break;
      case MESSAGES.portrait:
        messageType = '';
        break;
      default:
        messageType = '';
        break;
    }

    this.setState({ messageType, emailState });

    if (messageType !== '' && message !== MESSAGES.waiting && message !== MESSAGES.landscape) {
      setTimeout(() => this.setState({ messageType: '' }, () => {
        if (message === MESSAGES.sayHey) {
          messageHidden();
        }
      }), 4000);
    }
  }

  handleStartAttack = () => {
    const { startAttack } = this.props;

    this.setState(
      {
        jumpToAttack: true,
      },
      () => startAttack(),
    );
  };

  handleHasStopped = () => {
    const { jumpToAttack } = this.state;

    if (jumpToAttack) {
      this.setState({ jumpToAttack: false });
    }
  };

  handleSendEmail = () => {
    const { tryToSend } = this.props;
    const { messageType } = this.state;

    if (messageType === '') {
      tryToSend(true);
    }
  };

  onLoad = () => {
    const { characterIsLoaded } = this.props;

    characterIsLoaded();
  }

  render() {
    const {
      scrollPos,
      speedValues,
      charClass,
      canAnim,
      charAttack,
      stopMove,
      showMessage,
      freezeSpriteFrame,
    } = this.props;
    const {
      sprite, spriteConfs, move, jumpToAttack, messageType, emailState,
    } = this.state;

    return (
      <>
        <div className={`${isMobile ? 'mobile' : ''} ground-level`} ref={this.ground}>
          <Ground scrollPos={scrollPos} speedValues={speedValues} />
        </div>
        <div className="char-main-container">
          <SpritesheetAnim
            ref={node => {
              this.sprite = node;
            }}
            spritePath={sprite}
            spriteConfigs={spriteConfs}
            canAnim={canAnim}
            moveDirection={move}
            changeCharacter={this.changeCharacter}
            newCharacter={charClass}
            stopMove={stopMove}
            jumpToAttackMove={jumpToAttack}
            hasStopped={this.handleHasStopped}
            onLoad={this.onLoad}
            freezeSpriteFrame={freezeSpriteFrame}
          />
          {charAttack && charClass !== '' ? (
            <div
              tabIndex={-1}
              aria-label="Attack Button"
              role="button"
              className={`button ${charClass}`}
              onClick={this.handleStartAttack}
              onKeyPress={this.handleStartAttack}
            />
          ) : null}
          {showMessage !== '' && emailState && showMessage !== MESSAGES.success ? (
            <div
              tabIndex={-1}
              aria-label="Send Email Button"
              role="button"
              className="button send-email"
              onClick={this.handleSendEmail}
              onKeyPress={this.handleSendEmail}
            />
          ) : null }
          { showMessage !== '' && messageType !== '' ? (
            <div className={`char-talk ${messageType}`} />
          ) : null }
        </div>
      </>
    );
  }
}

BottomLayer.propTypes = propTypes;
BottomLayer.defaultProps = defaultProps;
